import { render, staticRenderFns } from "./history-rule.vue?vue&type=template&id=c9370e34&"
import script from "./history-rule.vue?vue&type=script&lang=js&"
export * from "./history-rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports